<div class="bn-spending-summary" data-testid="spending-summary">
  <section class="bn-spending-summary__section">
    <p class="bn-spending-summary__label">Available balance</p>
    <p class="bn-spending-summary__balance" data-testid="spending-balance">
      {{ summary().availableBalance }}
    </p>
  </section>

  <section class="bn-spending-summary__section">
    <p class="bn-spending-summary__label">Debit cards</p>
    @if (summary().cards.length === 0) {
      <p class="bn-spending-summary__empty" data-testid="spending-cards-empty">Not available</p>
    } @else {
      <ul class="bn-spending-summary__list">
        @for (card of summary().cards; track card.last4Label + card.chipLabel) {
          <li class="bn-spending-summary__item">
            <p-tag
              [value]="card.chipLabel"
              [severity]="cardSeverity(card.chipLabel)"
              [rounded]="true"
              styleClass="bn-accounts-status"
            />
            <span class="bn-spending-summary__last4">{{ card.last4Label }}</span>
          </li>
        }
      </ul>
    }
  </section>

  <bn-linked-accounts-list [section]="summary().linkedAccounts" />
</div>
